import _ from 'lodash';
import axios from 'axios';
import axiosInterceptor from '@ibiquity/dashboard.rollbar/src/axiosInterceptor';
import Rollbar from '@ibiquity/dashboard.rollbar';

axiosInterceptor.install(axios);

/* eslint-disable no-console */
export function getStaticMarketList() {
  return axios.get('/static/markets/list.json')
    .then(response => response.data);
}

export function getCustomMarketList() {
  const customMarketsItem = localStorage.getItem('customMarkets');
  return customMarketsItem ? JSON.parse(customMarketsItem) : [];
}

export function getStaticMarket(marketId) {
  let sanitizedMarket = marketId.replace(/\W/g, '');
  sanitizedMarket = _.kebabCase(sanitizedMarket);
  return axios.get(`/static/markets/${sanitizedMarket}.json?v=${Math.random()}`)
    .then((response) => {
      const market = response.data;
      console.info('Market Config Retrieved: ', market);
      return market;
    });
}

export function getCustomMarket(marketId) {
  const customMarket = getCustomMarketList().find(market => market.id === marketId);

  if (!customMarket) return null;

  console.info('Custom Market Config Retrieved: ', customMarket);
  return customMarket;
}

export function getMarket(marketId) {
  const customMarket = getCustomMarket(marketId);
  if (customMarket) return Promise.resolve(customMarket);
  return getStaticMarket(marketId);
}

export function getMarkets(marketIds) {
  return Promise.all(marketIds.map(getMarket))
    .catch(error => Rollbar.error(error));
}

export function saveCustomMarket(customMarket) {
  const customMarkets = getCustomMarketList();

  const index = _.findIndex(customMarkets, { id: customMarket.id });
  if (index === -1) {
    customMarkets.push(customMarket);
  } else {
    customMarkets.splice(index, 1, customMarket);
  }
  localStorage.setItem('customMarkets', JSON.stringify(customMarkets));
}

export function removeCustomMarket(id) {
  const customMarkets = getCustomMarketList();

  const index = _.findIndex(customMarkets, { id });
  if (index !== -1) {
    customMarkets.splice(index, 1);
    localStorage.setItem('customMarkets', JSON.stringify(customMarkets));
  }
}

export default {
  axios,
  getStaticMarket,
  getCustomMarket,
  getMarket,
  getMarkets,
  getStaticMarketList,
  getCustomMarketList,
  saveCustomMarket,
  removeCustomMarket,
};
